import { clsx, type ClassValue } from "clsx";
import { endOfDay, subDays } from "date-fns";
import parse from "html-react-parser";
import { DateRange } from "react-day-picker";
import sanitizeHtml from "sanitize-html";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function extractDate(date: Date | undefined) {
  if (!date) {
    throw new Error("Date is undefined");
  }

  return new Date(date).toLocaleDateString("en-CA");
}

export function htParse(html: string) {
  let parsed;

  try {
    parsed = parse(
      sanitizeHtml(html).replace(
        "<ul>",
        '<ul className="list-disc space-y-3">',
      ) ?? "",
    );
  } catch (error) {
    parsed = "HTML parsing failed.";
  }

  return parsed;
}

export function stringToDateRange(dateString: string): DateRange {
  const date = new Date();
  const to = endOfDay(date);
  switch (dateString) {
    case "1 Week":
      return {
        from: subDays(date, 7),
        to,
      };
    case "2 Weeks":
      return {
        from: subDays(date, 14),
        to,
      };
    case "1 Month":
      return {
        from: subDays(date, 30),
        to,
      };
    case "3 Months":
      return {
        from: subDays(date, 90),
        to,
      };
    case "6 Months":
      return {
        from: subDays(date, 180),
        to,
      };
    case "1 Year":
      return {
        from: subDays(date, 365),
        to,
      };
    case "5 Years":
      return {
        from: subDays(date, 1825),
        to,
      };
    case "10 Years":
      return {
        from: subDays(date, 3650),
        to,
      };
    default:
      return {
        from: subDays(date, 90),
        to,
      };
  }
}

export function normalizeTicker(ticker: string): string {
  if (!ticker || typeof ticker !== "string") {
    throw new Error("Invalid ticker input");
  }

  // Trim, uppercase, and extract the first word (the ticker symbol)
  const trimmedTicker = ticker.trim().toUpperCase();
  const tickerSymbol = trimmedTicker.split(/\s+/)[0];

  if (!tickerSymbol) {
    throw new Error("Ticker symbol is empty");
  }

  return `${tickerSymbol} US Equity`;
}
